const isComparisonSeriesItem = (
  item: ComparisonSeriesItem | HistogramSeriesItem | BarSeriesItem,
): item is ComparisonSeriesItem => {
  return item.data.length > 0 && !Array.isArray(item.data[0]);
};

export default isComparisonSeriesItem;
